<template>
  <div class="container">
    <app-table v-model="controls" :api="apiPedidos" :fields="fields">
      <template slot="header">
        <i class="fas fa-drumstick-bite"></i> Pedidos
      </template>
      <!-- Un Row -->
      <template slot="tr-item" slot-scope="pedido">
        <td class="text-right actions">
          <a
            :href="link_pedido_ver(pedido.row.id)"
            class="btn btn-primary btn-block"
          >
            <texto-resaltado
              :text="pedido.row.id | pedido_id2folio"
              :query="controls.query"
            >
            </texto-resaltado>
          </a>
        </td>
        <td class="text-right">{{ pedido.row.total | moneda }}</td>
        <td class="text-right">
          <texto-resaltado
            :text="pedido.row.created | dateTime"
            :query="controls.query"
          >
          </texto-resaltado>
        </td>
        <td class="text-right">
          <texto-resaltado
            :text="pedido.row.fecha_produccion | dateTime"
            :query="controls.query"
          >
          </texto-resaltado>
        </td>
        <td class="text-right">
          <texto-resaltado
            :text="pedido.row.fecha_reparto | dateTime"
            :query="controls.query"
          >
          </texto-resaltado>
        </td>
        <td
          class="text-right"
          :class="{ 'table-danger': pedido.row.cancelado }"
        >
          {{ pedido.row.cancelado ? "Sí" : "No" }}
        </td>
        <td :class="pedido.row.estado">
          <i :class="estado_icon(pedido.row.estado)"></i>
          {{ pedido.row.estado }}
        </td>
        <td class="actions">
          <button
            type="button"
            class="btn btn-dark btn-block"
            @click="mostrar_repartidores(pedido.row)"
            v-if="pedido.row.estado == 'produccion'"
          >
            <i class="fas fa-motorcycle"></i> Asignar repartidor
          </button>
          <button
            type="button"
            class="btn btn-dark btn-block"
            @click="cobrar_y_finalizar(pedido.row.id)"
            v-else-if="pedido.row.estado == 'cobro'"
          >
            <i class="fas fa-cash-register"></i> Cobrar &amp; Finalizar
          </button>
          <button
            type="button"
            class="btn btn-secondary btn-block btn-disabled"
            v-else
            disabled
          >
            <i class="fas fa-ban"></i> Accion no disponible
          </button>
        </td>
      </template>
      <template slot="footer">
        <router-link
          class="btn btn-primary btn-block"
          :to="{ name: 'PedidosProduccion' }"
        >
          <i class="fas fa-plus"></i> Ver en mapa
        </router-link>
      </template>
      <!-- Fin row -->
    </app-table>
    <!-- Modal -->

    <!-- Modal repartidores -->
    <modalSeleccionarRepartidor
      v-model="pedido_aux"
      v-on:asignar-pedido="asignar_pedido"
      ref="selecRepartidor"
    />
  </div>
</template>

<script>
import Pedido from "../../apis/Pedido";
import modalSeleccionarRepartidor from "@/views/repartidores/modalSeleccionar";
// import User from "../../apis/User";

export default {
  components: { modalSeleccionarRepartidor },
  data() {
    return {
      apiPedidos: Pedido,
      controls: {
        current_page: 1,
        per_page: 10,
        total: 0,
        query: "",
        sort_column: "created",
        sort_order: "desc",
        relations: [] // "items"
      },
      fields: [
        { display: "Folio" },
        { display: "Total" },
        { display: "Creado" },
        { display: "Asignado" },
        { display: "Entregado" },
        { display: "Cancelado" },
        { display: "Estado" },
        { display: "Acciones" }
      ],
      status: {
        produccion: "fa-user-clock",
        reparto: "fa-motorcycle",
        cobro: "fa-money-bill",
        finalizado: "fa-clipboard-check"
      }
    };
  },
  created() {},
  methods: {
    estado_icon: function(edo) {
      return "fas " + this.status[edo];
    },
    mostrar_repartidores: function(pedido) {
      this.$refs.selecRepartidor.mostrar_repartidores(pedido);
    },
    asignar_pedido: function(pedido) {
      if (pedido) {
        location.reload();
      }
    },
    cobrar_y_finalizar: function(pedido_id) {
      Pedido.cobrar_y_finalizar(pedido_id).then(e => {
        alert(JSON.stringify(e.data));
        location.reload();
      });
    },
    // devuelve el link del pedido con id
    link_pedido_ver: id => `/pedidos/ver/${id}`
  }, // end methods
  computed: {}
};
</script>

<style lang="scss" scoped>
.produccion,
.reparto,
.cobro,
.finalizado {
  color: white;
  background: #666;
  padding: 0.375rem 0.75rem !important;
}
.produccion {
  background: linear-gradient(90deg, #c45900, #e01818);
}
.reparto {
  background: linear-gradient(90deg, #a21525, #820917);
}
.cobro {
  background: linear-gradient(90deg, #800097, #600f6f);
}
.finalizado {
  background: linear-gradient(90deg, #048cec, #043cec);
}
.modal-body {
  padding-top: 0 !important;
}
</style>
